export const formatDbPuzzleToStateStructure = (puzzleData) => {
  const gameId = puzzleData.gameId || puzzleData.gameUrl?.split("/").pop();

  const source =
    puzzleData.source ||
    (puzzleData._id && puzzleData._id.includes("-analysis")
      ? "analysis"
      : puzzleData.gameId
      ? "database_new_format"
      : "unknown");

  const topVars =
    Array.isArray(puzzleData.topVariations) &&
    puzzleData.topVariations.every(Array.isArray)
      ? puzzleData.topVariations
      : [];

  const bestLineForDisplay = topVars.length > 0 ? topVars[0] : [];

  const initialBoardFen = puzzleData.fenBeforeOpponent || puzzleData.puzzleFen;

  const blunderDetails = {
    fen: puzzleData.puzzleFen,
    gameId: gameId,
    gameUrl: puzzleData.gameUrl,
    opponent: puzzleData.opponentUsername,
    opponentLastMoveSanBeforeBlunder:
      puzzleData.opponentLastMoveSanBeforeBlunder,
    userColor: puzzleData.userPlayedAs,
    blunderMoveSan: puzzleData.blunderMoveSan,
    blunderPly: puzzleData.blunderPly,
    fenBeforeOpponent: puzzleData.fenBeforeOpponent,
    prevEvalCp: puzzleData.evaluationBeforeCp,
    currentEvalCp: puzzleData.evaluationAfterCp,
    evalDropCp: puzzleData.evaluationDropCp,
    awaitingDynamicEngineMove: false,
    gameSource: puzzleData.gameSource,
    bestLine: bestLineForDisplay,
    topVariations: topVars,
    isFullyAnalyzed: puzzleData.isFullyAnalyzed,
    analysisDepth: puzzleData.analysisDepth,
    source: source,
    puzzleSolved: false,
    incorrectMove: false,
  };

  return {
    id:
      puzzleData._id ||
      `${gameId || "unknownGame"}-${puzzleData.puzzleFen}-${
        puzzleData.blunderPly
      }`,
    initialFen: initialBoardFen,
    currentFen: initialBoardFen,
    playedMovesSan: [],
    blunderDetails: blunderDetails,
    moveHistory: [initialBoardFen],
    currentMoveIndex: 0,
    puzzleInteractiveStartIndex: 0,
    analysisMoveTree: null,
    analysisCurrentNode: null,
  };
};
export const puzzleStatusMessages = (params) => {
  const {
    loadingGames,
    loadingPuzzles,
    loadingProcessedGames,
    analyzing,
    error,
    username,
    chesscomUsername,
    games,
    puzzleStates,
    isEngineReady,
    lichessUsername,
    onOpenArchive,
    onImportPgn,
  } = params;

  if (!isEngineReady) {
    return (
      <p>
        Waiting for analysis engine...{" "}
        <span style={{ fontSize: "0.8em", color: "#888" }}>
          (Reconnecting automatically)
        </span>
      </p>
    );
  }
  if (puzzleStates && puzzleStates.length > 0) {
    return null;
  }
  if (loadingGames || loadingPuzzles || loadingProcessedGames) {
    return <p>Loading user data, games, and existing puzzles...</p>;
  }
  if (analyzing)
    return (
      <p>Processing games: Checking database and analyzing new games...</p>
    );
  if (error)
    return (
      <p className="error-message" style={{ color: "red" }}>
        Error: {error}
      </p>
    );
  if (!chesscomUsername && !lichessUsername && username)
    return (
      <p>
        Link a Chess.com or Lichess account in your profile to start analyzing
        games.
      </p>
    );

  if (
    !analyzing &&
    puzzleStates.length === 0 &&
    games.length > 0 &&
    isEngineReady
  ) {
    return (
      <div style={{ textAlign: "center", margin: "20px 0" }}>
        <p>Analysis complete. No new blunders found in recent games.</p>
        <p style={{ fontSize: "0.9em", color: "#666" }}>
          Great job! You are all caught up, play more games to generate new
          puzzles.
        </p>
        <button
          onClick={onOpenArchive}
          style={{
            marginTop: "10px",
            padding: "10px 20px",
            backgroundColor: "#4F3B7B",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "1em",
          }}
        >
          View Puzzle Archive
        </button>
        <button
          onClick={onImportPgn}
          style={{
            padding: "10px 20px",
            marginLeft: "10px",
            backgroundColor: "#28a745",
            color: "white",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "1em",
          }}
        >
          Import PGN
        </button>
      </div>
    );
  }

  if (
    !analyzing &&
    puzzleStates.length === 0 &&
    games.length === 0 &&
    (chesscomUsername || lichessUsername)
  )
    return <p>No recent games found for analysis...</p>;

  return null;
};
